import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import {MatSortModule} from '@angular/material/sort';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ChartsModule } from 'ng2-charts';


@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    MatSortModule,
    FormsModule,ReactiveFormsModule,Ng2SearchPipeModule,
    NgbAlertModule,NgMultiSelectDropDownModule,NgbPaginationModule,ChartsModule
  ]
})
export class DashboardModule { }
